var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartphone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 80.0700 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4824 5.9082L60.5469 5.9082C63.4277 5.9082 65.4297 3.95508 65.4297 1.07422L65.4297-71.6309C65.4297-74.5117 63.4277-76.4648 60.5469-76.4648L19.4824-76.4648C16.6504-76.4648 14.6484-74.5117 14.6484-71.6309L14.6484 1.07422C14.6484 3.95508 16.6504 5.9082 19.4824 5.9082Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.5269101f09f03b281d7d0b3dacdd0b9d.svg";
export { ForwardRef as ReactComponent };